// covered-by: qa/rickrubin/tests/api/ask-puntt-notification-prefs.spec.ts
// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import { NotificationsSettingsView } from "./NotificationsSettingsView";

import { canAccessAskPuntt, requiresAuth } from "../../../utils/auth";
import { authLayoutRoute } from "../../auth-layout/route";
import { ticketsRoute } from "../../tickets/route";

export const notificationsSettingsRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "notifications-settings",
  beforeLoad() {
    if (!canAccessAskPuntt()) {
      throw redirect({ to: ticketsRoute.to } as any);
    }
    requiresAuth();
  },
  component: NotificationsSettingsView,
});
